import { useEffect, useRef } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { RECAPTCHA_SITE_KEY } from '@shared/config/recaptcha';

const RecaptchaWidgetContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RecaptchaWidget: React.FC = () => {
  if (!grecaptcha) throw new Error('undefined grecaptcha');

  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    grecaptcha.enterprise.ready(() => {
      if (!ref.current) return;
      grecaptcha.enterprise.render(ref.current, { sitekey: RECAPTCHA_SITE_KEY });
    });
  }, []);

  return (
    <RecaptchaWidgetContainer>
      <div ref={ref} />
    </RecaptchaWidgetContainer>
  );
};
